import immutableStore from 'alt-utils/lib/ImmutableUtil';
import DefaultTriggerRuleActions from 'actions/triggers/DefaultTriggerTagActions';
import alt from 'components/Dispatcher';

@immutableStore
class DefaultTriggerTagStore {
  constructor() {
    this.state = {
      tags: undefined,
      loading: false,
      errored: false,
    };
    this.bindActions(DefaultTriggerRuleActions);
  }

  fetchDefaultTriggerTags() {
    this.setState({
      tags: undefined,
      loading: true,
      errored: false,
    });
  }

  fetchDefaultTriggerTagsSuccess(tags) {
    this.setState({
      tags: tags,
      loading: false,
      errored: false,
    });
  }

  fetchDefaultTriggerTagsError(e) {
    console.error(e);

    this.setState({
      tags: undefined,
      loading: false,
      error: true,
    });
  }
}

export default alt.createStore(DefaultTriggerTagStore);
